import React from 'react';
import { Link } from 'react-router-dom';
import { CaretLeft, CaretRight } from '@phosphor-icons/react';

const pageList = (page, total) => {
  const set = new Set([1, total, page - 1, page, page + 1].filter((p) => p >= 1 && p <= total));
  const sorted = [...set].sort((a, b) => a - b);
  const out = [];
  sorted.forEach((p, i) => { if (i && p - sorted[i - 1] > 1) out.push('…' + p); out.push(p); });
  return out;
};

export const Pagination = ({ page, totalPages, hrefFor }) => {
  if (totalPages <= 1) return null;
  const base = 'min-w-[2.5rem] h-10 px-3 inline-flex items-center justify-center rounded font-mono text-sm transition-colors';
  return (
    <nav className="flex items-center justify-center gap-1.5 flex-wrap my-8" aria-label="Inventory pages" data-testid="pagination">
      {page > 1 ? (
        <Link to={hrefFor(page - 1)} rel="prev" className={`${base} bg-[#11141D] border border-[#334155] text-white hover:border-cyan-400`} data-testid="pagination-prev">
          <CaretLeft size={14} className="mr-1" /> Prev
        </Link>
      ) : <span className={`${base} border border-[#1E293B] text-[#475569]`}><CaretLeft size={14} className="mr-1" /> Prev</span>}
      {pageList(page, totalPages).map((p) => (typeof p === 'string'
        ? <span key={p} className="px-1 text-[#475569]">…</span>
        : (
          <Link key={p} to={hrefFor(p)} aria-current={p === page ? 'page' : undefined}
            className={`${base} ${p === page ? 'bg-cyan-500 text-[#05050A] font-bold' : 'bg-[#11141D] border border-[#334155] text-[#CBD5E1] hover:border-cyan-400'}`}
            data-testid={`pagination-page-${p}`}>
            {p}
          </Link>
        )))}
      {page < totalPages ? (
        <Link to={hrefFor(page + 1)} rel="next" className={`${base} bg-[#11141D] border border-[#334155] text-white hover:border-cyan-400`} data-testid="pagination-next">
          Next <CaretRight size={14} className="ml-1" />
        </Link>
      ) : <span className={`${base} border border-[#1E293B] text-[#475569]`}>Next <CaretRight size={14} className="ml-1" /></span>}
    </nav>
  );
};

export default Pagination;
